import Cookies from 'js-cookie';

'use strict';

var windowIsTurbolinked = 'Turbolinks' in window;

var browserWarning = {
  init: function() {
    var browserWarningOKButton = document.querySelector('.browser-warning-ok');

    if (browserWarningOKButton) {
      this.addListener(browserWarningOKButton);
      // clear turbolinks cache so browser warning banner does not reappear
      windowIsTurbolinked && window.Turbolinks.clearCache();
    }
  },

  addListener: function(target) {
    // Support for IE < 9
    if (target.attachEvent) {
      target.attachEvent('onclick', this.setCookie);
    } else {
      target.addEventListener('click', this.setCookie, false);
    }
  },

  setCookie: function() {
    var isSecure = location.protocol === 'https:';
    Cookies.set('browser_warning_acked', true, { path: '/', expires: 7, secure: isSecure });

    var container = document.querySelector('.browser-warning');
    container.parentNode.removeChild(container);
  }
};

(function() {
  function eventName(fallback) {
    return windowIsTurbolinked ? 'turbolinks:load' : fallback
  }

  var isCalled = false;

  function isReady() {
    // return early when browserWarning.init has been called AND Turbolinks is NOT included
    // when Turbolinks is included browserWarning.init has to be called on every page load
    if (isCalled && !windowIsTurbolinked) {
      return
    }
    isCalled = true;

    browserWarning.init();
  }

  if (document.addEventListener) {
    return document.addEventListener(eventName('DOMContentLoaded'), isReady, false);
  }

  // Old browsers IE < 9
  if (window.addEventListener) {
    window.addEventListener(eventName('load'), isReady, false);
  } else if (window.attachEvent) {
    window.attachEvent(eventName('onload'), isReady);
  }
})();
